$(function () {
    const $spacesTable = $('#yr5-spaces-table');

    if ($spacesTable.length === 0) {
        return;
    }

    $spacesTable.DataTable({
        pageLength: -1,
        lengthMenu: [[25, 50, -1], [25, 50, 'All']],
    });

    const $editForm   = $('#yr5-placement-spaces-edit-form');
    const $editModal  = $('#yr5-placement-spaces-edit-modal');
    const $saveButton = $editForm.find('[type="submit"]');

    $('.yr5-placement-spaces-edit-btn').on('click', function () {
        var button    = $(this);
        var placement = JSON.parse(button.attr('data-placement'));

        $editForm.find('[name="original-placement"]').val(
            JSON.stringify(placement)
        );

        $editForm.find('[name="placement-id"]').val(
            placement.id
        );

        $editModal.find('.placement-name').text(
            placement.name + ', ' + placement.town
        );

        $editModal.find('.placement-type').text(
            placement.category === 'MEDICAL' ? 'MED' : 'SURG'
        );

        for (var block = 1; block <= numberOfBlocks; block++) {
            $('#block' + block).val(placement['block' + block]);

            $editForm.find('[name="block' + block + '-id"]').val(
                placement['block' + block + '_id']
            );
        }

        updateSaveButton();

        $editModal.modal('show');
    });

    $editForm.on('change', '[id^="block"]', function () {
        updateSaveButton();
    });

    // Ensure save button is disabled until something changes
    function updateSaveButton() {
        var originalPlacement = JSON.parse(
            $editForm.find('[name="original-placement"]').val()
        );

        var hasChanged = false;

        for (var block = 1; block <= numberOfBlocks; block++) {
            var spaces         = $('#block' + block).val();
            var originalSpaces = originalPlacement['block' + block];

            if (Number(spaces) !== Number(originalSpaces)) {
                hasChanged = true;

                break;
            }
        }

        $saveButton.prop('disabled', !hasChanged);
    }
});
